import {transApi} from '@/axios'
// 查询项目列表
export function projectList(sendData) {
    return transApi({
        url: '/project/page',
        method: 'post',
        data: sendData
    })
}

// 导出项目
export function projectExport() {
    return transApi({
        url: '/project/export/all',
        method: 'get',
        responseType: "blob"
    })
}


// 释放原始数据
export function projectRelease(id) {
    return transApi({
        url: '/project/verifyRawData/'+id,
        method: 'get',
    })
}

// 删除项目
export function projectDel(id) {
    return transApi({
        url: '/project/' + id,
        method: 'delete'
    })
}
// 编辑项目信息（类型+备注）
export function projectEdit(data) {
    return transApi({
        url: '/project',
        method: 'put',
        data:data
    })
}
export function projectCustomerEdit(data) {
    return transApi({
        url: '/project/customer/remark',
        method: 'put',
        data:data
    })
}
// / 更改项目的用户
export function projectChangeUser(data) {
    return transApi({
        url: '/project/editUsers',
        method: 'put',
        data:data
    })
}
// 最后10条
export function projectLast_10_trans(){
    return transApi({
        url: '/project/last-10',
        method: 'get',
    })
}
// 获取渐变色
export function getGradientByColor(data){
    return transApi({
        url: '/tool/color/gradient',
        method: 'post',
        data:data
    })
}
export function analyzeItemListByProjects_trans(sendData){
    return transApi({
        url: '/analyze/analyzeItemListByProjects',
        method: 'post',
        data: sendData
    })
}

export function customerProjectsBySalesName_trans(sendData){
    return transApi({
        url: '/project/customer-projects-by-sales',
        method: 'post',
        data: sendData
    })
}

export function projectLivenessPage_trans(sendData){
    return transApi({
        url: '/project/projectLivenessPage',
        method: 'post',
        data: sendData
    })
}

export function customerLivenessPage_trans(sendData){
    return transApi({
        url: '/project/customerLivenessPage',
        method: 'post',
        data: sendData
    })
}
